import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/percepciones-limite-maximo';

/**
 * GET Percepciones Limite Maximo
 * @param {object} params - Usualmente { percepcion: id }
 * @returns {Promise<object[]>}
 */
export const getPercepcionesLimiteMaximo = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Percepcion Limite Maximo individual
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPercepcionLimiteMaximo = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Percepcion Limite Maximo
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPercepcionLimiteMaximo = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Percepcion Limite Maximo
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPercepcionLimiteMaximo = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Percepcion Limite Maximo
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePercepcionLimiteMaximo = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
